import React, { useEffect, useState, useCallback } from "react";
import { Stack, Container, Row, Col, Form } from "react-bootstrap";
import PropertyDetailsCard from "../MyBids/PropertyDetailsCard/PropertyDetailsCard";
import {
  getBuyerDetails,
  getBuyerOffers,
  getCIFDetails,
  getOfferDetailsById,
  getBuyerSelfOffers,
  getBuyerOffersByName,
  getTrasactionByName,
} from "@/api/offers";
import OfferDetailsModal from "./OfferDetailModal/OfferDetailsModal";
import { throttle } from "lodash";
import { ShimmerContentBlock } from "react-shimmer-effects";
import DashboardSectionWrapper from "../components/DashboardSectionWrapper";
import OfferDetailsCard from "./OfferDetailsCard";
import "./MyOffer.css";
import { getTrasaction } from "@/api/bids";
import { trackButtonClick } from "@/utils/analytics";
import HistoryCard from "./HistoryCard";
import { getCookie } from "@/utils/cookies";

const MyOffers = () => {
  const [offers, setOffers] = useState([]);
  const [filteredOffers, setFilteredOffers] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [selectedOfferDetails, setSelectedOfferDetails] = useState(null);
  const [buyerDetails, setBuyerDetails] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState(null);
  const [filterType, setFilterType] = useState("all");
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [buyersName, setBuyersName] = useState([]);
  const [buyerData, setBuyerData] = useState({});
  const [selectedFilter, setSelectedFilter] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [transactionData, setTransactionData] = useState([]);
  const [cifIds, setCifIds] = useState([]);
  const [reload,setReload] = useState(false)
  const emailId = getCookie("userEmail")

  const getAllOffers = async () => {
    try {
      setLoading(true);
      const response = await getBuyerOffers(page);
      const newOffers = response.offerList || [];
      const cif = newOffers?.map((data) => data?.activeOffer?.offerId);
      const cifData = await getCIFDetails(cif);
      setCifIds(cifData);
      setOffers(newOffers);
      setFilterType("all");

    } catch (error) {
      setLoading(false);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getAllOffers();
    getBuyerNames();
  }, [reload]);
  useEffect(() => {
  const handleScroll = throttle(() => {
    if (
      window.innerHeight + window.scrollY >= document.body.offsetHeight - 300 &&
      !loading &&
      hasMore &&
      !showHistory
    ) {
      loadMoreOffers();
    }
  }, 300);

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, [loading, hasMore, page, showHistory, filterType]);
const loadMoreOffers = async () => {
  try {
    // setLoading(true);
    const nextPage = page + 1;
    let newData;

    if (filterType === "all") {
      newData = await getBuyerOffers(nextPage);
    } else {
      const key = Object.entries(buyerData).find(
        ([key, name]) => name === filterType
      )?.[0];
      const payload = encodeURIComponent(key);
      newData = await getBuyerOffersByName({ payload, page: nextPage });
    }

    const newOffers = newData.offerList || [];
    if (newOffers.length === 0) {
      setHasMore(false);
    } else {
      const newCifs = newOffers.map((data) => data?.activeOffer?.offerId);
      const cifData = await getCIFDetails(newCifs);
      // setCifIds((prev) => [...prev, ...cifData]);
      // setCifIds((prev = []) => [...prev, ...(Array.isArray(cifData) ? cifData : [])]);
setCifIds((prev) => ({ ...prev, ...cifData }));

      setOffers((prev) => [...prev, ...newOffers]);
      setPage(nextPage);
    }
  } catch (err) {
    console.error("Error loading more offers", err);
    setHasMore(false);
  } finally {
    setLoading(false);
  }
};


  const handleOfferDetailsClick = () => {};

  const getBuyerNames = async () => {
    try {
      const data = await getBuyerDetails();
      setBuyersName(Object.values(data));
      setBuyerData(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleFilterChange = async (e) => {
    setFilterType(e.target.value);
    const entry = Object.entries(buyerData).find(
      ([key, name]) => name === e.target.value
    );

    const key = entry ? entry[0] : null;
    const payload = encodeURIComponent(key);

    trackButtonClick({
      eventName: "my_offers_apply_filter",
      eventCategory: "My Offers",
      eventSource: `On filter dropdown click - ${e.target.value}`,
      eventLabel:
        e.target.value === "all"
          ? "No Filters Selected"
          : e.target.value === "self"
          ? `Filter: ${e.target.value}`
          : `Filter: ${key}`,
    });

    if (showHistory) {
      if (e.target.value === "all") {
        const data = await getTrasaction(page);
        const newOffers = data.offerList || [];
        setTransactionData(newOffers);
        setSelectedFilter(false);
      }else if(e.target.value === "self"){
         const data = await getBuyerOffersByName({ payload: emailId});
        const newOffers = data.offerList || [];
        setOffers(newOffers);
        setSelectedFilter(true);
      } else {
        const data = await getTrasactionByName({ payload, page });
        const newOffers = data.offerList || [];
        setTransactionData(newOffers);
        setSelectedFilter(true);
      }
    } else {
      if (e.target.value === "all") {
        const data = await getBuyerOffers(page);
        const newOffers = data.offerList || [];
        setOffers(newOffers);
        setSelectedFilter(false);
      }else if(e.target.value === "self"){
         const data = await getBuyerOffersByName({ payload: emailId});
        const newOffers = data.offerList || [];
        setOffers(newOffers);
        setSelectedFilter(true);
      }
       else {
        const data = await getBuyerOffersByName({ payload });
        const newOffers = data.offerList || [];
        setOffers(newOffers);
        setSelectedFilter(true);
      }
    }
  };

  const getHistoryData = async () => {
    try {
      setShowHistory(!showHistory);
      if (!showHistory) {
        const data = await getTrasaction(page);
        setTransactionData(data?.offerList);
      } else {
        getAllOffers();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <DashboardSectionWrapper
      title="My Offers"
      showBidOrOfferToggleBtn
      myBidsOrOfferToggleText={showHistory ? "Go Back" : "History"}
      handleToggleBidOrOfferHistory={() => {
        getHistoryData();
        trackButtonClick({
          eventName: "transaction_view_toggle",
          eventCategory: "My Offers",
          eventSource: showHistory ? "on go back click" : "On history click",
          eventParams: { view: !showHistory ? "previous" : "active" },
        });
      }}
    >
      {loading ? (
        <div className="p-4">
          {[...Array(3)].map((_, index) => (
            <div key={index} className="mb-4 cfd-shimmer-wrapper">
              <ShimmerContentBlock
                title
                text
                cta
                thumbnailWidth={180}
                thumbnailHeight={100}
              />
            </div>
          ))}
        </div>
      ) : (
        <>
          {offers?.length === 0 && !selectedFilter ? (
            <div className="text-center noOffers-div p-4">
              Currently you do not have active offers on any of the properties
            </div>
          ) : (
            <>
              {Object.values(buyerData)?.length > 0 && (
                <div className="container myoffer-dropdown">
                  <Form.Label className="px-2 offer-drop-label">
                    By Buyer
                  </Form.Label>
                  {/* <Col sm="10"> */}
                  <Form.Select
                    className="w-25"
                    value={filterType}
                    onChange={handleFilterChange}
                  >
                    <option value="all">All</option>
                    <option value="self" >Self</option>
                    {Object.entries(buyerData).map(([key, name], index) => (
                      <option key={index} value={name}>
                        {name}
                      </option>
                    ))}
                  </Form.Select>
                  {/* </Col> */}
                </div>
              )}

              {showHistory ? (
                <>
                  {transactionData?.length > 0 ? (
                    <>
                     <div className="my-offer-header d-none d-sm-block">
                        <div className="row">
                          <p className="col-2 offer-header-title">
                            Property Details
                          </p>
                          <p className="col-8 offer-header-title">Address</p>
                          <p className="col-2 offer-header-title text-center">
                            Actions
                          </p>
                        </div>
                      </div>
                        {
                          transactionData?.map((data, index)=><><HistoryCard key={index} data={data}/></>)
                        }
                    </>
                  ) : (
                    <>
                      <p className=" text-center robotolight-myoffer">
                        {!selectedFilter ? (
                          <>
                            Currently you do not have previous transaction on
                            any of the properties
                          </>
                        ) : (
                          <>No Records found for the filters applied.</>
                        )}
                      </p>
                    </>
                  )}
                </>
              ) : (
                <>
                  {offers?.length === 0 && selectedFilter ? (
                    <div className="text-center robotolight">
                      No Records found for the filters applied.
                    </div>
                  ) : (
                    <>
                      <div className="my-offer-header d-none d-sm-block">
                        <div className="row">
                          <p className="col-2 offer-header-title">
                            Property Details
                          </p>
                          <p className="col-4 offer-header-title">Address</p>
                          <p className="col-3 offer-header-title">Status</p>
                          <p className="col-3 offer-header-title text-center">
                            Actions
                          </p>
                        </div>
                      </div>
                      {offers.map((propertyData, index) => (
                        <OfferDetailsCard
                          key={propertyData.propertyId || index}
                          data={[propertyData]}
                          loading={loading}
                          componentType="offers"
                          cifArray={cifIds}
                          onOfferDetailsClick={() =>
                            handleOfferDetailsClick(
                              propertyData.activeOffer.offerId
                            )
                          }
                          setReload={setReload}
                        />
                      ))}
                    </>
                  )}
                </>
              )}
            </>
          )}
        </>
      )}
    </DashboardSectionWrapper>
  );
};

export default MyOffers;
